<ng-container>
  <div class="col col-lg-8 offset-lg-2">
    @for (page of blogPages; track page) {
      <wl-blog-post
        [image]="page.image"
        [title]="page.title.value"
        [description]="page.description.value"
        [url]="page.url"
        [labels]="page.tagArray"
        [readMoreLabel]="data?.fields?.ReadMoreLabel"
        [a11yReadMoreLabel]="page.a11yReadMoreLabel"
      ></wl-blog-post>
    }
  </div>
</ng-container>
